import { render, staticRenderFns } from "./ComposicaoItemLista.vue?vue&type=template&id=0207018f&"
import script from "./ComposicaoItemLista.vue?vue&type=script&lang=js&"
export * from "./ComposicaoItemLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports